@if (resume) {
  <div class="horizontal-large profile-card">
    <div class="portrait">
      <img [src]="resume.subData.content?.portraitImageUrl" />
    </div>
    <div class="text-body vertical no-gap">
      <div class="name">{{ resume.subData.content?.firstName }} {{ resume.subData.content?.lastName }}</div>
      <div class="position">
        {{ resume.subData.content?.mostRecentPosition }} &#64;
        {{ resume.subData.content?.mostRecentCompany }}
      </div>
    </div>
  </div>
}
